var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-4 py-3 border-b sm:px-6 md:py-3 bg-grey-bg "},[_c('div',{staticClass:"progress-steps"},[_c(_vm.step > 1 ? 'router-link' : 'span',{tag:"component",staticClass:"progress-step is-first",class:{
                'is-active': _vm.step === 1,
                'is-highlighted': _vm.step >= 1
            },attrs:{"to":_vm.step > 1 ? { name: 'residencies.welcome.show' } : null}},[_c('span',{staticClass:"progress-label"},[_vm._v("Welcome")])]),_vm._v(" "),_c('span',{staticClass:"progress-step",class:{
                'is-active': _vm.step === 2,
                'is-highlighted': _vm.step >= 2
            }},[_c('span',{staticClass:"progress-label"},[_vm._v("Account")])]),_vm._v(" "),_c('div',{staticClass:"progress-step is-last",class:{
                'is-active': _vm.step === 3,
                'is-highlighted': _vm.step >= 3,
            }},[_c('span',{staticClass:"progress-label"},[_vm._v("Accept")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }